import { format, isSameDay } from "date-fns";
import * as React from "react";
import * as dateRange from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { TDateProperties } from "../../../modules/OrderModule/table-tabs/orderStateReducer";
import useClickOutSide from "../../../utils/custom-hooks/useClickOutside";
import "./ZFDateRangePicker.scss";
import {
	getDefaultStaticRanges,
	isCustomDateRange,
	TDateRange,
	TDateRangeType,
} from "./defaultStaticRanges";

const DateRangePicker = dateRange.DateRangePicker;

interface IDateRangePickerProps {
	dateProps: TDateProperties;
	onDateChange: (range: TDateRange) => void;
}
let count = 0;
const ZFDateRangePicker: React.FC<IDateRangePickerProps> = ({
	dateProps,
	onDateChange,
}) => {
	const defaultStaticRanges = getDefaultStaticRanges(dateProps.config);
	const dateRangeInit = {
		selection: {
			startDate: dateProps.dateRange.startDate,
			endDate: dateProps.dateRange.endDate,
			key: "selection",
		},
	};

	const [dateSelected, setDateSelected] = React.useState(
		dateRangeInit.selection
	);

	const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);

	const toggleCalendar = () => {
		isCalendarOpen ? hide() : show();
		setIsCalendarOpen(!isCalendarOpen);
	};

	React.useEffect(() => {
		hide();
		count = 0;
	}, []);

	const handleDate = (item) => {
		const range: TDateRange = { ...item.selection };
		setDateSelected(item.selection);

		if (!isCalendarOpen) {
			onDateChange(range);
			return;
		}
		if (count) {
			onDateChange(range);
			count = 0;
			hide();
			setIsCalendarOpen(!isCalendarOpen);
		} else {
			count++;
		}
	};

	const hide = () => {
		const someElement = document.getElementsByClassName(
			"rdrCalendarWrapper"
		)[0];

		if (someElement) {
			someElement.classList.add("rdrCalendarWrapper-hide");
		}
	};

	const show = () => {
		const someElement = document.getElementsByClassName(
			"rdrCalendarWrapper-hide"
		)[0];
		someElement.classList.remove("rdrCalendarWrapper-hide");
	};

	const hideOnClickOutSide = () => {
		console.log("hideOnClickOutSide");
		if (isCalendarOpen) {
			if (count === 1) {
				const d = (({ startDate, endDate }) => ({
					startDate,
					endDate,
				}))({ ...dateSelected });
				count = 0;
				onDateChange(d);
			}
			hide();
			setIsCalendarOpen(!isCalendarOpen);
		}
	};

	const clickOutsideRef = useClickOutSide(hideOnClickOutSide);

	return (
		<div
			className="date-range-selector"
			ref={clickOutsideRef}
		>
			<div className="zf-text-black zf-text-s zf-margin-r-xxl-m date-select-lbl">
				Delivery date:
			</div>
			<DateRangePicker
				onChange={handleDate}
				months={2}
				direction="vertical"
				ranges={[dateSelected]}
				staticRanges={defaultStaticRanges}
				inputRanges={[]}
			/>
			<ShowCustomDate
				rangeTypes={dateProps.config}
				range={dateSelected}
				toggleCalender={toggleCalendar}
			/>
		</div>
	);
};

export default ZFDateRangePicker;

interface IShowCustomDate {
	rangeTypes: TDateRangeType[];
	range: TDateRange;
	toggleCalender: () => void;
}

const ShowCustomDate: React.FC<IShowCustomDate> = ({
	rangeTypes,
	range,
	toggleCalender,
}) => {
	const isCustom = isCustomDateRange(rangeTypes, range);
	const formattedDate = (range: TDateRange) => {
		return isSameDay(range.startDate, range.endDate)
			? formatDateDisplay(range.startDate)
			: `${formatDateDisplay(range.startDate)} to ${formatDateDisplay(
					range.endDate
			  )}`;
	};
	return (
		<button
			type="button"
			className={`date-range-btn ${
				isCustom ? "date-range-btn--selected" : ""
			}`}
			onClick={() => toggleCalender()}
		>
			{isCustom ? <span>{formattedDate(range)}</span> : "Custom"}
		</button>
	);
};

const DATE_DISPLAY_FORMAT = "MMM dd yyyy";

const formatDateDisplay = (d: Date) => {
	return format(d, DATE_DISPLAY_FORMAT);
};
